import Question from "./components/question/Question";
import Results from "./components/results/Results";
import data from "./data.json";
import { useSelector, useDispatch } from "react-redux";
import { next } from "./slices/questionReducer";
import { useEffect } from "react";

function App() {
  const activeQuestion = useSelector((state) => state.question.activeQuestion);
  const dispatch = useDispatch();
  useEffect(() => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }, []);
  return (
    <div>
      {activeQuestion < data.length ? (
        <div className="px-6 window ">
          <Question
            data={data[activeQuestion]}
            next={(chosen) =>
              dispatch(
                next({
                  ...data[activeQuestion].answers[chosen],
                  type: data[activeQuestion].type,
                })
              )
            }
          />

          {activeQuestion == 0 && (
            <div className="pb-2 text-center px-3 -z-50">
              <a href="https://www.getmoneycoach.co.uk/privacy-policy">
                <span className="text-[14px] leading-[10px] opacity-70 text-white">
                  You can find out how we use your data and how to contact us
                  with any queries <i className="underline not-italic">here</i>.
                </span>
              </a>
            </div>
          )}
        </div>
      ) : (
        <div>
          <Results />
        </div>
      )}
    </div>
  );
}

export default App;
